export default __webpack_public_path__ + "static/media/wippy_download_page_text_en.1e221628.svg";